import React from 'react';
import {themeable, styled} from '@packages/utilities/styled';
import {Flexbox} from './Flexbox';

const LoaderCircle = themeable(
  ({
    theme,
    // @ts-expect-error - TS2339 - Property 'small' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    small = false,
    // @ts-expect-error - TS2339 - Property 'block' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    block = false,
    // @ts-expect-error - TS2339 - Property 'currentColor' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    currentColor = false,
    // @ts-expect-error - TS2339 - Property 'style' does not exist on type '{ theme: Theme; } & RefAttributes<any> & { children?: ReactNode; }'.
    style: externalStyles,
  }) => {
    const strokeWidth = small ? 2 : 3;
    const size = small ? 15 : 30;
    const margin = Math.ceil(strokeWidth / 2);
    const d = size - margin * 2;
    const r = d / 2;

    let style = externalStyles;

    if (block) {
      // Icons in packages/systems/ui/icons are always display: block.
      // This component probably should have display: block by default
      // to be consistent with them, but this component is used in
      // a lot of places without that. Hence, this is opt-in for now.
      style = {...style, display: 'block'};
    }

    return (
      <svg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
        stroke={currentColor ? 'currentColor' : theme.colors.foregroundVivid}
        fill="none"
        fillRule="evenodd"
        strokeWidth={strokeWidth}
        style={style}
      >
        <g transform={`translate(${margin} ${margin})`}>
          <g transform="rotate(0)">
            <circle strokeOpacity=".3" cx={r} cy={r} r={r} />
            <path d={`M ${r} 0 A ${r} ${r} 0 0 0 0 ${r}`} />
            <animateTransform
              attributeName="transform"
              begin="0s"
              dur="1s"
              type="rotate"
              from={`0 ${r} ${r}`}
              to={`360 ${r} ${r}`}
              repeatCount="indefinite"
            />
          </g>
        </g>
      </svg>
    );
  }
);

export default LoaderCircle;

const CircleView = styled(Flexbox)(({theme}) => ({
  backgroundColor: theme.colors.background,
}));

export const PaneLoadingIndicatorCircle = () => (
  <CircleView
    paddingTop={8}
    paddingBottom={8}
    width="100%"
    height="100%"
    justifyContent="center"
  >
    <LoaderCircle />
  </CircleView>
);
